import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PdfReaderComponent } from './components/pdf-reader/pdf-reader.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { PdfReaderDialogComponent } from './components/pdf-reader-dialog/pdf-reader-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { PdfReaderDirective } from './directives/pdf-reader.directive';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';



@NgModule({
  declarations: [
    PdfReaderComponent,
    PdfReaderDialogComponent,
    PdfReaderDirective
  ],
  imports: [
    CommonModule,
    PdfViewerModule,
    MatDialogModule,
    MatButtonModule,
    TranslateModule,
    MatIconModule
  ],
  exports: [
    PdfReaderComponent,
    PdfReaderDialogComponent,
    PdfReaderDirective
  ]
})
export class PdfReaderModule { }
